module.exports = __webpack_public_path__ + "static/font-ecd69a53da6c1626c7e69c0cd4b04b3f.png";